<template>
   <div class="right">
      <div class="title-box">
        <span class="curr">企业名录</span>
      </div>
      <div class="img-box">
        <div class="photo">
          <p class="job">主任单位：</p>
          <div class="flexH">
            <div class="mr-23 flexVC2">
              <img class="photo-img" src="@/assets/img/icon_gongsi_img1.png" alt="">
            </div>
            <div class="mr-23 flexVC2">
              <img class="photo-img" src="@/assets/img/icon_gongsi_img2.png" alt="">
            </div>
            <div class="mr-23 flexVC2">
              <img class="photo-img" src="@/assets/img/icon_gongsi_img3.png" alt="">
            </div>
          </div>
        </div>
        <div class="photo">
          <p class="job">副主任单位：</p>
          <div class="flexH">
            <div class="mr-23 flexVC2">
              <img class="photo-img" src="@/assets/img/icon_leader_img.png" alt="">
            </div>
            <div class="mr-23 flexVC2">
              <img class="photo-img" src="@/assets/img/icon_leader_img.png" alt="">
            </div>
            <div class="mr-23 flexVC2">
              <img class="photo-img" src="@/assets/img/icon_leader_img.png" alt="">
            </div>
          </div>
        </div>
        <div class="photo">
          <p class="job">理事单位：</p>
          <div class="flexH">
            <div class="mr-23 flexVC2">
              <img class="photo-img" src="@/assets/img/icon_leader_img.png" alt="">
            </div>
          </div>
        </div>
        <div class="photo">
          <p class="job">会员单位：</p>
          <div class="flexH">
            <div class="mr-23 flexVC2">
              <img class="photo-img" src="@/assets/img/icon_leader_img.png" alt="">
            </div>
          </div>
        </div>
      </div>
   </div>
</template>
<script>
export default {
  data() {
    return {
      leftList: [
        '会员服务',
        '发起单位',
        '企业名录',
        '企业风采',
        '人物专访',
        '会员表彰',
        '企业展示',
        '会员申请',
      ]
    }
  }
};
</script>
<style lang="less" scoped>

.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  .head-img {
    width: 438px;
    height: 290px;
    margin: 20px auto 51px auto;
    display: block;
  }
  .photo {
    border-top: 1px solid #F8F8FB;
    padding: 30px 0;
    .job {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1B252C;
      line-height: 25px;
    }
    .photo-img {
      width: 149px;
      height: 80px;
      margin-top: 20px;
    }
    .name {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1B252C;
      line-height: 25px;
      margin-top: 15PX;
    }
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
